// useKontaktRollen.ts — lädt den Rollenkatalog der Kontaktanlage EINMAL vom
// Server (`GET /api/kontakt-rollen`) und setzt ihn als aktiven Katalog in
// `data/kontaktRollen.ts`. Schlägt das fehl (Endpoint fehlt — lokal proxied
// Vite an einen DEV-Server ohne ihn —, Netzfehler, unerwartete Antwort),
// bleibt der eingebaute `ROLLEN_BEREICHE`: die Anlage funktioniert unverändert.

import * as React from "react";
import {
  aktuellerRollenKatalog,
  katalogAusServer,
  setzeRollenKatalog,
  type RollenBereich,
} from "../data/kontaktRollen";
import { kontaktRollenLaden } from "./kontaktRollenService";

let laden: Promise<RollenBereich[]> | null = null;

function einmalLaden(): Promise<RollenBereich[]> {
  if (!laden) {
    laden = kontaktRollenLaden()
      .then((roh) => {
        setzeRollenKatalog(katalogAusServer(roh));
        return aktuellerRollenKatalog();
      })
      .catch(() => {
        setzeRollenKatalog(null);
        return aktuellerRollenKatalog();
      });
  }
  return laden;
}

/** Nach Änderungen in den Einstellungen: beim nächsten Gebrauch neu laden. */
export function kontaktRollenNeuLaden(): void {
  laden = null;
}

/**
 * Der Katalog für die Anlage. Beim ersten Render der eingebaute (oder der
 * bereits geladene), nach dem Laden der des Mandanten — die Komponente
 * rendert dann neu, und die Funktionen aus `data/kontaktRollen.ts` arbeiten
 * mit ihm.
 */
export function useKontaktRollen(): RollenBereich[] {
  const [katalog, setKatalog] = React.useState<RollenBereich[]>(aktuellerRollenKatalog);
  React.useEffect(() => {
    let lebt = true;
    einmalLaden().then((k) => {
      if (lebt) setKatalog(k);
    });
    return () => {
      lebt = false;
    };
  }, []);
  return katalog;
}
